import React, { useState, useMemo } from 'react';
import { Spin, Table, Empty, Button } from 'antd-v5';
import moment from 'moment';
import { LoadingOutlined } from '@ant-design/icons';
import { Link, useHistory } from 'react-router-dom';
import MessageConfigToday from './MessageConfigToday';
import '../today.css';

const TodayRecentMessages = props => {
  const [isShown, setIsShown] = useState('');
  const history = useHistory();

  const columns = useMemo(
    () => [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '20%',
        render: (text, record) => (
          <Link to={`/Clients?client=${record.client_id}`}>{text}</Link>
        ),
      },
      {
        title: 'Message',
        dataIndex: 'last_msg',
        key: 'last_msg',
        width: '50%',
        ellipsis: true,
      },
      {
        title: '',
        dataIndex: 'message_action',
        key: 'message_action',
        width: '15%',
        align: 'center',
        render: (_, record) => (
          <div className="align-center pos-rel" style={{ maxHeight: '34px' }}>
            <MessageConfigToday
              keyVar={Math.floor(Math.random() * record.id)}
              msgObj={record}
              setShowPopConfirm={props.setShowPopConfirm}
              initiateTemplates={props.initiateTemplates}
              setIsShown={setIsShown}
              isShown={isShown}
            />
          </div>
        ),
      },
      {
        title: 'Time',
        dataIndex: 'last_sent_timestamp',
        key: 'last_sent_timestamp',
        width: '15%',
        align: 'right',
        render: timestamp => {
          if (timestamp) {
            return moment.unix(timestamp / 1000).fromNow(true);
          }
          return null;
        },
      },
    ],
    [props.setShowPopConfirm, props.initiateTemplates, isShown],
  );

  return (
    <div className="m-btm-35">
      <div className="flex-row-spacebetween-nowrap m-btm-10">
        <span className="fs-15 fw-500">Recent Messages</span>
        <Button
          type="link"
          className="cb-link-btn"
          id="MyInbox"
          onClick={() => history.push('/Messaging/inbox')}
        >
          My Inbox
        </Button>
      </div>
      {props.isLoading ? (
        <div className="w-100-P flex-col-center m-top-10">
          <Spin tip="Loading..." size="large" indicator={<LoadingOutlined spin />}>
            <div
              style={{
                padding: 50,
                background: 'rgba(0, 0, 0, 0.1)',
                borderRadius: 8,
              }}
            />
          </Spin>
        </div>
      ) : (
        <Table
          className="today-table"
          columns={columns}
          dataSource={props.data}
          rowKey={(record, index) => record.id || `${record.client_id}-${index}`}
          pagination={false}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Messages" />,
          }}
        />
      )}
    </div>
  );
};

export default TodayRecentMessages;
